<div class="modal-header" id="material-availability-modal-title">
    <h3 class="modal-title" translate="MATERIAL_AVAILABILITY_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="materialAvailabilityForm">
        <fieldset [disabled]="isLoading">
            <div class="row mb-3">
                <div class="col-12 col-md-3 d-flex justify-content-md-end">
                    <label
                        class="col-form-label text-nowrap"
                        for="materialNumber"
                        translate="MATERIAL_AVAILABILITY_LABEL_MATERIALNUMBER"
                    ></label>
                </div>
                <div class="col-10 col-md-5">
                    <pace-core-text-input
                        id="materialNumber"
                        name="materialNumber"
                        [parentForm]="formChildren"
                        [(model)]="model.materialNumber"
                        [ariaLabel]="'MATERIAL_AVAILABILITY_LABEL_MATERIALNUMBER' | translate"
                    ></pace-core-text-input>
                </div>
                <div class="col-2 ms-md-auto">
                    <button
                        id="btnMaterialAdd"
                        type="button"
                        class="btn btn-primary float-end"
                        translate="MATERIAL_AVAILABILITY_LABEL_BUTTON_ADD"
                        [disabled]="isLoading || materialAvailabilityForm.invalid"
                        (click)="addMaterial()"
                    ></button>
                </div>
            </div>
            <div class="row">
                <div class="d-flex table-header fw-bold py-2">
                    <div class="col-1"></div>
                    <div class="col-3" translate="MATERIAL_AVAILABILITY_LABEL_MATERIAL"></div>
                    <div class="col-3" translate="MATERIAL_AVAILABILITY_LABEL_STORAGE_LOCATION"></div>
                    <div class="col-3" translate="MATERIAL_AVAILABILITY_LABEL_AVAILABLE"></div>
                    <div
                        class="col-1"
                        *ngIf="showMaterialPricingInfo"
                        translate="MATERIAL_AVAILABILITY_LABEL_CUSTOMER_PRICING"
                    ></div>
                    <div class="col-1"></div>
                </div>
            </div>
            <div class="row" *ngIf="model.partSet.value.length > 0">
                <div class="row d-flex align-items-center" *ngFor="let material of model.partSet.value; index as index">
                    <div class="col-1"></div>
                    <div class="col-3">{{ material.materialNr.value }}</div>
                    <div class="col-3"></div>
                    <div class="col-3"></div>
                    <div class="col-1">
                        <div *ngIf="showMaterialPricingInfo"></div>
                    </div>
                    <div class="col-1 d-flex align-items-center justify-content-center py-2">
                        <button
                            class="btn btn-danger"
                            (click)="deleteMaterial(index)"
                            [attr.aria-label]="
                                ('MATERIAL_AVAILABILITY_DELETE_MATERIAL_ARIA_LABEL' | translate) + (i + 1)
                            "
                        >
                            <fa-icon [icon]="faTrashAlt"></fa-icon>
                        </button>
                    </div>
                    <div class="col-12" *ngIf="index < model.partSet.value.length - 1">
                        <hr class="my-2" />
                    </div>
                </div>
            </div>
            <div>
                <div class="row" *ngIf="responsePartSet.length > 0">
                    <div class="table-row" *ngFor="let material of responsePartSet; let last = last">
                        <pace-material-availability-details [material]="material" [responsePartSet]="responsePartSet">
                        </pace-material-availability-details>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <progressbar *ngIf="isLoading" [value]="100" type="default">Loading...</progressbar>
    <div class="me-auto" *ngIf="!isLoading && sparePartsCatalogLink" paceCoreLink>
        <a
            class="btn btn-primary"
            href="{{ sparePartsCatalogLink }}"
            target="_blank"
            translate="SPARE_PARTS_CATALOG_LINK_LABEL"
        ></a>
    </div>
    <button
        *ngIf="!isLoading"
        class="btn btn-primary ms-auto"
        type="button"
        translate="MATERIAL_AVAILABILITY_LABEL_BUTTON_CHECK"
        (click)="check()"
    ></button>
</div>
